import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
function CertificateMockup() {
  return <div className="w-full bg-white rounded-2xl border border-[#9aa6af] shadow-xl shadow-carbon-deep/5 overflow-hidden" data-id="element-1002">
      <div className="flex items-center justify-between px-6 py-4 border-b border-carbon-geo bg-gray-50/80" data-id="element-1003">
        <div className="flex items-center gap-2.5" data-id="element-1004">
          <div className="w-8 h-8 rounded-lg bg-carbon-bright flex items-center justify-center" data-id="element-1005">
            <span className="text-white text-xs font-bold" data-id="element-1006">CS</span>
          </div>
          <div data-id="element-1007">
            <p className="text-sm font-bold text-carbon-deep leading-tight" data-id="element-1008">
              Digital Quality Certificate
            </p>
            <p className="text-[10px] text-carbon-deep" data-id="element-1009">
              CarbonSafe dMRV Platform
            </p>
          </div>
        </div>
        <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-carbon-bright/10 border border-carbon-bright/20" data-id="element-1010">
          <span className="w-2 h-2 rounded-full bg-carbon-bright" data-id="element-1011" />
          <span className="text-xs font-bold text-carbon-bright uppercase tracking-wider" data-id="element-1012">
            Verified
          </span>
        </span>
      </div>
      <div className="p-6 space-y-5" data-id="element-1013">
        <div className="grid grid-cols-2 gap-x-6 gap-y-4" data-id="element-1014">
          <div data-id="element-1015">
            <p className="text-[10px] font-semibold text-carbon-deep/60 uppercase tracking-wider" data-id="element-1016">
              Origin
            </p>
            <p className="text-sm font-bold text-carbon-deep mt-0.5" data-id="element-1017">
              Mt. Elgon, Uganda
            </p>
          </div>
          <div data-id="element-1018">
            <p className="text-[10px] font-semibold text-carbon-deep/60 uppercase tracking-wider" data-id="element-1019">
              Grade
            </p>
            <p className="text-sm font-bold text-carbon-deep mt-0.5" data-id="element-1020">
              Bugisu AA
            </p>
          </div>
          <div data-id="element-1021">
            <p className="text-[10px] font-semibold text-carbon-deep/60 uppercase tracking-wider" data-id="element-1022">
              Lot ID
            </p>
            <p className="text-sm font-bold text-carbon-deep mt-0.5 font-mono" data-id="element-1023">
              #UG-2026-04821
            </p>
          </div>
          <div data-id="element-1024">
            <p className="text-[10px] font-semibold text-carbon-deep/60 uppercase tracking-wider" data-id="element-1025">
              Harvest Date
            </p>
            <p className="text-sm font-bold text-carbon-deep mt-0.5" data-id="element-1026">
              Jan 2026
            </p>
          </div>
          <div data-id="element-1027">
            <p className="text-[10px] font-semibold text-carbon-deep/60 uppercase tracking-wider" data-id="element-1028">
              Farmer Co-op
            </p>
            <p className="text-sm font-bold text-carbon-deep mt-0.5" data-id="element-1029">
              Sipi Falls Cooperative
            </p>
          </div>
          <div data-id="element-1030">
            <p className="text-[10px] font-semibold text-carbon-deep/60 uppercase tracking-wider" data-id="element-1031">
              GPS Verified
            </p>
            <p className="text-sm font-bold text-carbon-bright mt-0.5 flex items-center gap-1" data-id="element-1032">
              <CheckCircle2Icon className="w-3.5 h-3.5" data-id="element-1033" />
              1.2847°N, 34.3478°E
            </p>
          </div>
        </div>
        <div className="border-t border-carbon-geo" data-id="element-1034" />
        <div data-id="element-1035">
          <p className="text-[10px] font-semibold text-carbon-deep/60 uppercase tracking-wider mb-3" data-id="element-1036">
            Compliance Status
          </p>
          <div className="flex flex-wrap gap-2" data-id="element-1037">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-carbon-bright/5 border border-[#9aa6af] text-xs font-semibold text-carbon-deep" data-id="element-1038">
              <CheckCircle2Icon className="w-3.5 h-3.5 text-carbon-bright" data-id="element-1039" />
              EUDR Compliant
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-carbon-bright/5 border border-[#9aa6af] text-xs font-semibold text-carbon-deep" data-id="element-1040">
              <CheckCircle2Icon className="w-3.5 h-3.5 text-carbon-bright" data-id="element-1041" />
              UCDA Certified
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-carbon-bright/5 border border-[#9aa6af] text-xs font-semibold text-carbon-deep" data-id="element-1042">
              <CheckCircle2Icon className="w-3.5 h-3.5 text-carbon-bright" data-id="element-1043" />
              Deforestation-Free
            </span>
          </div>
        </div>
        <div className="border-t border-carbon-geo" data-id="element-1044" />
        <div className="flex items-end justify-between" data-id="element-1045">
          <div data-id="element-1046">
            <div className="w-16 h-16 rounded-lg border border-[#9aa6af] p-1.5 bg-white" data-id="element-1047">
              <div className="w-full h-full grid grid-cols-5 grid-rows-5 gap-px" data-id="element-1048">
                {[1, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 1, 1].map((filled, i) => <div key={i} className={`rounded-[1px] ${filled ? 'bg-carbon-deep' : 'bg-transparent'}`} data-id="element-1049" />)}
              </div>
            </div>
            <p className="text-[10px] text-carbon-deep mt-1.5 font-medium" data-id="element-1050">
              Scan to verify
            </p>
          </div>
          <p className="text-[10px] text-carbon-deep/50 text-right leading-snug" data-id="element-1051">
            Independently verified by
            <br data-id="element-1052" />
            <span className="font-semibold text-carbon-deep/70" data-id="element-1053">
              CarbonSafe dMRV
            </span>
          </p>
        </div>
      </div>
    </div>;
}
export function ProductShowcaseDMRV() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="w-full bg-white py-20 sm:py-28 border-t border-b border-carbon-geo" data-id="element-1054">

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1055">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-1056">
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.7,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-1057">

            <CertificateMockup data-id="element-1058" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.7,
          delay: 0.15,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-1059">

            <p className="text-sm font-semibold uppercase tracking-widest text-carbon-bright" data-id="element-1060">
              Verified impact
            </p>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-carbon-deep tracking-tight leading-tight" data-id="element-1061">
              From field data to verified impact
            </h2>
            <p className="mt-6 text-lg text-carbon-deep leading-relaxed" data-id="element-1062">
              CarbonSafe puts data capture in farmers' hands and
              enterprise-grade reporting in boardrooms — outputting verifiable
              certificates and compliance reports that unlock trade, finance,
              and market access.
            </p>
            <ul className="mt-8 space-y-4" data-id="element-1063">
              {['USSD field data capture on any phone, no internet needed', 'Automated Scope 1, 2 & 3 GHG inventory for enterprises', 'Tamper-proof Digital Quality Certificates for every lot', 'IFRS S1/S2, CSRD, CBAM, and EUDR compliance in one platform', 'Independent third-party verification trusted by regulators'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-1064">
                  <CheckCircle2Icon className="w-5 h-5 text-carbon-bright mt-0.5 flex-shrink-0" data-id="element-1065" />
                  <span className="text-carbon-deep" data-id="element-1066">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}